export default __webpack_public_path__ + "static/media/daCrazyHomeSection.3fb83f36.svg";